import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ImSearch } from "@react-icons/all-files/im/ImSearch.esm.js";
import { IoClose } from "@react-icons/all-files/io5/IoClose.esm.js";
import useFilter from '@unmapped/core/hooks/useFilter';
import { decorateName } from '@unmapped/core/utils';
import useComponentOverride from "../../hooks/useComponentOverride.js";
import useStyleOverride from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
export var FuzzySearchFilter = decorateName(observer(_ref => {
  var {
    name,
    showSortIndicator = false
  } = _ref;
  var {
    filterState,
    setFilterState,
    setOnApplySnapshot
  } = useFilter(name);
  var styles = useStyleOverride('filters/FuzzySearchFilter', baseStyles);
  var [TextInput, InlineControlGroup, SortIndicator] = useComponentOverride('controls/TextInput', 'layout/InlineControlGroup', 'results/SortIndicator');
  var inputRef = useRef(null);
  var [isCollapsed, setIsCollapsed] = useState(!!filterState);
  var initialRenderRef = useRef(true);
  useEffect(() => {
    setOnApplySnapshot(snapshot => {
      if (inputRef.current) {
        var _snapshot$state;
        inputRef.current.value = (_snapshot$state = snapshot.state) !== null && _snapshot$state !== void 0 ? _snapshot$state : '';
      }
      if (snapshot.state && snapshot.state.length > 0) setIsCollapsed(true);
    });
  }, []);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = filterState !== null && filterState !== void 0 ? filterState : '';
      setIsCollapsed(true);
    }
    if (initialRenderRef.current) initialRenderRef.current = false;
  }, [!!inputRef.current, initialRenderRef.current]);
  var mouseOutRef = useRef(null);
  return /*#__PURE__*/React.createElement(InlineControlGroup, {
    className: styles.FuzzySearchFilter
  }, /*#__PURE__*/React.createElement(TextInput, {
    minimal: true,
    ref: inputRef,
    placeholder: "Search...",
    onClick: () => showSortIndicator && setIsCollapsed(true),
    onFocus: () => showSortIndicator && setIsCollapsed(true),
    onBlur: e => showSortIndicator && !e.target.value && setIsCollapsed(false),
    onChange: e => {
      setFilterState(e.target.value ? e.target.value : null);
    }
  }, /*#__PURE__*/React.createElement(ImSearch, {
    className: styles.searchIcon,
    size: 16
  }), filterState && /*#__PURE__*/React.createElement("div", {
    title: "Clear",
    className: styles.cancel,
    onClick: () => {
      if (!inputRef.current) return;
      inputRef.current.value = '';
      inputRef.current.focus();
      setFilterState(null);
      if (showSortIndicator && !isCollapsed) setIsCollapsed(true);
    }
  }, /*#__PURE__*/React.createElement(IoClose, {
    size: 14
  }))), showSortIndicator && /*#__PURE__*/React.createElement(SortIndicator, {
    isCollapsed: isCollapsed,
    setIsCollapsed: setIsCollapsed,
    onMouseOver: () => {
      var _inputRef$current;
      if (mouseOutRef.current) {
        clearTimeout(mouseOutRef.current);
        mouseOutRef.current = null;
      }
      if (!((_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.value)) {
        setIsCollapsed(false);
      }
    },
    onMouseOut: () => {
      if (mouseOutRef.current) clearTimeout(mouseOutRef.current);
      mouseOutRef.current = setTimeout(() => {
        if (inputRef.current && inputRef.current.value) {
          setIsCollapsed(true);
        }
        if (mouseOutRef.current) {
          clearTimeout(mouseOutRef.current);
          mouseOutRef.current = null;
        }
      }, 2000);
    }
  }));
}), 'FuzzySearchFilter');
export default FuzzySearchFilter;
//# sourceMappingURL=index.js.map